export class LoginFormModel {
  password = '';
  email = '';
  rememberMe = false;
}
